import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** RichText property - Definition */
export class DocsBlockRichTextPropertyDefinition extends DocsBlockPropertyDefinition {
}
